import React from "react";
import { observer } from "mobx-react";
import { WalletStore } from "../../stores/wallet/wallet-store";
import { NOTE_TYPE } from "../../../../components/note/note";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { FontBody2 } from "../../../../components/fonts/font-body2/font-body2";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import { Note } from "../../../../components/note/note";
import "./wallet-payment-method-error-top-bar.scss";
import WalletPaymentMethodErrorModal from "./wallet-payment-method-error-modal";

interface Props {
    walletStore: WalletStore;
}

const WalletPaymentMethodErrorTopBar: React.FC<Props> = observer(({ walletStore }: Props) => {
    return (
        <>
            <Note
                type={NOTE_TYPE.WARNING}
                body={
                    <div className="wallet-payment-method-error-top-bar">
                        <div className="wallet-payment-method-error-top-bar-content">
                            <div className="wallet-payment-method-error-top-bar-text">
                                <FontBody2 variant={FONT_VARIANT.BOLD}>{"Payment Failed"}</FontBody2>
                                <FontBody2>{`Your payment of ${walletStore.failedDepositTransactionsStore.amountFormattedWithCurrencySymbol} using ${walletStore.brand} ****${walletStore.last4} couldn't be completed. Please update your payment method.`}</FontBody2>
                            </div>
                        </div>
                        <div className="wallet-payment-method-error-top-bar-buttons">
                            <Button
                                variant={BUTTON_VARIANTS.Tertiary}
                                text="More details"
                                onClick={() => walletStore.failedDepositTransactionsStore.setShouldShowPaymentMethodErrorModal(true)}
                            />
                            <Button
                                variant={BUTTON_VARIANTS.Primary}
                                isLoading={walletStore.isAddingPaymentMethod}
                                hasLoader={true}
                                text="Update Payment Method"
                                onClick={walletStore.addPaymentMethodHandler}
                            />
                        </div>
                    </div>
                }
            />
            {walletStore.failedDepositTransactionsStore.shouldShowPaymentMethodErrorModal && (
                <WalletPaymentMethodErrorModal
                    failedDepositTransactionsStore={walletStore.failedDepositTransactionsStore}
                    walletStore={walletStore}
                    onCloseClick={() => walletStore.failedDepositTransactionsStore.setShouldShowPaymentMethodErrorModal(false)}
                />
            )}
        </>
    );
});

export default WalletPaymentMethodErrorTopBar;
